import React from 'react';
import EventDetails from '../events/EventDetails';

function EventDetailsPopup({ eventId, onClose }) {
  return (
    <div className="event-details-popup-content">
      <EventDetails eventId={eventId} variant="popup" onClose={onClose} />
    </div>
  );
}

export default EventDetailsPopup;






